import { useState } from 'react';
import styled from 'styled-components';

import MobilePageHeader from 'components/shared/MobilePageHeader';
import { useCoordinatePatientsActions } from 'stores/patientFiltersStore';
import { Label } from 'styles/typography';
import CoordinatePatientsIcon from 'svg/CoordinatePatientsIcon';

import { CoordinateContentProps } from './contentProps';
import CoordinateEmpty from './CoordinateEmpty';
import PatientList from './CoordinatePatientList';
import { SearchButton } from './CoordinateSearch';

const MobileSearchHeader = ({ onSearch, isLoading }: { onSearch: (search: string) => void; isLoading: boolean }) => {
  const [searchValue, setSearchValue] = useState('');

  return (
    <MobilePageHeader
      title={'Coordinate'}
      actionElement={null}
      search={searchValue}
      setSearch={setSearchValue}
      onEnter={onSearch}
      placeholder='Search'>
      <SearchButton {...{ searchValue, onSearch, isLoading }} />
    </MobilePageHeader>
  );
};

function CoordinateMobileContent({
  patients,
  onAddToPortfolio,
  contentRequester,
  resultString = '',
  isLoading = false,
}: CoordinateContentProps) {
  const { setSearch } = useCoordinatePatientsActions();

  return (
    <>
      <MobileSearchHeader onSearch={setSearch} isLoading={isLoading} />
      {!patients && (
        <CoordinateEmpty
          message='Enter a name or ID to get started'
          icon={<CoordinatePatientsIcon color='currentColor' />}
        />
      )}
      {patients && !patients?.length && <CoordinateEmpty message={resultString} />}
      {patients && !!patients?.length && (
        <ResultsContainer>
          <Label fontSize='14' style={{ marginBottom: 10 }}>
            {resultString}
          </Label>
          <PatientList {...{ patients, onAddToPortfolio }} />
          {contentRequester}
        </ResultsContainer>
      )}
    </>
  );
}

const ResultsContainer = styled.div`
  display: flex;
  flex: 1;
  width: 100%;
  flex-direction: column;
  gap: 8px;
  padding: 18px;
  overflow: auto;
`;

export default CoordinateMobileContent;
